
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payment-gateway/red-services",
      function () {
        return require("private-next-pages/payment-gateway/red-services.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payment-gateway/red-services"])
      });
    }
  